import script from "./BaseMixinComponent.vue?vue&type=script&lang=js"
export * from "./BaseMixinComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__